module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai304-962192ee3dfded6e0d8dd6bf859447ba.jpg";